(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pride-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ---- Countdown ----
  var SALE_END = new Date('2026-06-21T23:59:59').getTime();
  function pad(n){ return String(n).padStart(2,'0'); }
  function tick(){
    var diff = Math.max(0, SALE_END - Date.now());
    var v = {
      days: Math.floor(diff/86400000),
      hours: Math.floor((diff%86400000)/3600000),
      mins: Math.floor((diff%3600000)/60000),
      secs: Math.floor((diff%60000)/1000)
    };
    document.querySelectorAll('[data-cd]').forEach(function(el){
      el.textContent = pad(v[el.getAttribute('data-cd')]);
    });
  }
  tick(); setInterval(tick, 1000);

  // ---- Copy coupon ----
  document.querySelectorAll('.lp-copy').forEach(function(btn){
    btn.addEventListener('click', function(){
      var code = btn.getAttribute('data-code');
      if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function(){});
      btn.classList.add('copied');
      setTimeout(function(){ btn.classList.remove('copied'); }, 2000);
    });
  });

  // ---- FAQ accordion (single, collapsible) ----
  document.querySelectorAll('#lp-faq-list .lp-faq-item').forEach(function(item){
    var trigger = item.querySelector('.lp-faq-trigger');
    var content = item.querySelector('.lp-faq-content');
    trigger.addEventListener('click', function(){
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('#lp-faq-list .lp-faq-item.open').forEach(function(o){
        o.classList.remove('open');
        o.querySelector('.lp-faq-content').style.maxHeight = null;
      });
      if (!isOpen){
        item.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
